import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {ChangeSet} from "../../domain/entities/change-set.interface";
import {KnowledgeObject} from "../../domain/entities/knowledge-object.entity";
import {MessageBroker} from "../../message-broker/message-broker";
import {EntityChangedPayload} from "../../message-broker/payloads/entity-changed.payload";
import {CommandBus} from "../../services/command-bus.service";
import {UpdateKnowledgeObjectMetadataCommand, type UpdateKnowledgeObjectMetadataPayload} from "../update-knowledge-object-metadata.command";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(UpdateKnowledgeObjectMetadataCommand)
@singleton()
export class UpdateKnowledgeObjectMetadataCommandHandler implements ICommandHandler<UpdateKnowledgeObjectMetadataPayload> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(MessageBroker) private readonly _messageBroker: MessageBroker,
    ) {
    }

    // Publishes entity.changed only on backend ACK so listeners (EntityLiveRefreshController)
    // do not reload on a rejected rename (PRD-076 Failure Condition 7).
    public async handle(command: UpdateKnowledgeObjectMetadataCommand): Promise<void> {
        if (!(await this._commandBus.addSendCommand(command))) {
            return;
        }
        const uid = command.payload.objectUid;
        this._messageBroker.publish<EntityChangedPayload<KnowledgeObject>>({
            type: `entity.changed`,
            identityHash: uid,
            payload: {
                uid,
                prototype: KnowledgeObject,
                changeSet: {} as ChangeSet<KnowledgeObject>,
            }
        });
    }

}
